import styled from 'styled-components'

export const Bg = styled.div`
  min-height: 100vh;
  width: 100%;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: white;
  min-height: 100vh;
`

export const ContentLayout = styled.div`
  padding-top: 0;
  min-height: 100vh;
`
